import * as React from "react";
import Card from '@material-ui/core/Card'
import CardActionArea from "@material-ui/core/CardActionArea"
import CardMedia  from "@material-ui/core/CardMedia"
import IconButton from "@material-ui/core/IconButton"
import { makeStyles } from '@material-ui/core/styles'

import { IoIosAddCircleOutline } from 'react-icons/io'

import FormControl from "@material-ui/core/FormControl"
import InputLabel from "@material-ui/core/InputLabel"

import SelectFileContentDialog from 'components/dialogs/SelectFileContentDialog'

import { promotionPackageClassFactory } from "schema/promotions"

import { inputLabelStyle, formControlStyle } from 'jimbo/ui/Style'

const useStyles = makeStyles(theme => ({
    addPanel: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-end',
    },
    imageContainer: {
        marginBottom: 4,
        color: theme.palette.text.primary,
        flexGrow: 1
    },
    card: {
        maxWidth: 345,
    },
}));



const SelectImageWidget = ({ id, label, instance, fieldName, path, formConfigurations }) => {
    const classes = useStyles()
    const formControlClasses = formControlStyle()
    const inputLabelClasses = inputLabelStyle()

    const [open, setOpen] = React.useState(false);


    const field = instance.$fields.get(fieldName)
    const isTouched = field.isTouched
    const hasErrors = field.errors
    const showError = isTouched && hasErrors;
    const value = field.value ? field.value : null


    const imageUrl = value ? value.getFieldValue('imageUrl') : null

    const handleClickOpenImageSelect = () => {
        setOpen(true);
    };

    const handleCancelImageSelect = () => {
        setOpen(false);
    }

    const handleCloseImageSelect = (selectedImage) => {

        if (selectedImage) {
            // note selectedImage is a contentObjectRepresentation of an imageObject
            console.log("Dialog selected ", selectedImage)
            setOpen(false);
            const contentObjectId = selectedImage.id

            const imageUrl = selectedImage.renditions[0].defaultImage.url
            const initialData = { id: contentObjectId, imageUrl: imageUrl }
            const value = promotionPackageClassFactory.createInstance("ImageContainerProxy", { initialData });
            instance.setValue(fieldName, value);
        } else {
            instance.setValue(fieldName, null);
        }

    };




    return <FormControl error={showError} fullWidth classes={formControlClasses}>
        {open ?
            <SelectFileContentDialog assetType="image" typeLabel="Image" open={open} handleCancel={handleCancelImageSelect} handleClose={handleCloseImageSelect}></SelectFileContentDialog>
            : null}

        <InputLabel shrink={false} classes={inputLabelClasses} htmlFor={id}>
            {label}
        </InputLabel>
        <div className={classes.imageContainer}>
            {imageUrl ?
                <Card className={classes.card}>
                    <CardActionArea>
                        <CardMedia
                            component="img"
                            height="100"
                            image={imageUrl}
                        />
                    </CardActionArea>
                </Card> : null}
        </div>
        <IconButton edge="end" aria-label="add" onClick={(event) => handleClickOpenImageSelect(event)} >
            <IoIosAddCircleOutline size={16} />
        </IconButton>
    </FormControl>
}




export default SelectImageWidget;